import React from 'react';

import { styled } from '@mui/material/styles';
import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 250px;
    p {
        font-weight: bold;
        font-size: 12px;
    }
`;

const EmptyMessage = ({ children, text }) => (
    <Grid container>
        <Grid size={{ xs: 'grow' }}>
            <Wrapper>
                <p>{text}</p>
                {children}
            </Wrapper>
        </Grid>
    </Grid>
);

EmptyMessage.propTypes = {
    children: PropTypes.node,
    text: PropTypes.string,
};

export default EmptyMessage;
